import { CustomStepCategoryEnum, OfferIntents, OfferTypes } from './../../_models/funnel';
import { BaseModel } from '../../_models/base-model';
import { Audience } from '../../_models/audiences';

export interface Step extends BaseModel {
  category: CustomStepCategoryEnum;
  display_id: number;
  useExternalButtons?: boolean;
}

export interface RetentionOffer extends BaseModel {
  display_id: number;
  is_modified: boolean;
  name: string;
  updated: string;
  offer_intent: OfferIntents;
  offer_type: OfferTypes;
  paths: BaseModel[];
  is_active: boolean;
  segments_count: number;
  steps: Step[];
  audience: Audience;
  sessions?: number;
  cancels?: number;
  saves?: number;
  segments?: string[] | number[];
  previewLoading?: boolean;
  showThreeDotMenu?: boolean;
  offerName: string;
  survey: FirstStep;
  isPublishing?: boolean;
  enabled?: boolean;
  reactivate_path: number;
}

export interface RetentionTable {
  id: number;
  displayId: number;
  offerName: string;
  status: number;
  sessions: string;
  cancels: string;
  saves: string;
  segments: number;
  isActive: boolean;
  offerType: number;
  type: number;
  tooltip: string;
  showThreeDotMenu?: boolean;
  previewLoading?: boolean;
  lastModified: {
    time: string;
    date: string;
  };
}

export interface FirstStep {
  id: number;
  funnel: number;
  name: string;
  slug: string;
  label: string; // HTML string
  type: number;
  created: string; // ISO datetime
  updated: string; // ISO datetime
  show_step_link: boolean;
  category: number;
  offer_intent: number;
}

export interface SingleStep extends RetentionOffer {
  first_step: FirstStep;
  is_public: boolean;
  campaign: string | number;
  enabled: boolean;
  campaigns: (string | number)[];
}

export interface PopupData {
  name?: string | null;
  offer_type?: OfferTypes;
  popupType?: number | null;
  offer_id?: number | string;
  segment_funnel_id?: number;
  audience_id?: number | string;
  offer_type_options?: DropdownOption[];
  conditions?: string[];
  offer_intent?: OfferIntents;
  is_survey_response?: boolean;
}

export interface DropdownOption {
  value: string;
  label: string;
}

export const OfferIntentPriority: Record<number, number> = {
  [OfferIntents.CancelSubscription]: 1, // Subscription Active
  [OfferIntents.CancelSubscriptionHold]: 2, // Subscription Initial Order
  [OfferIntents.CancelRebillHold]: 3, // Subscription Rebill Order
  [OfferIntents.CancelOrder]: 4, // One-Time Order
  [OfferIntents.CancelTrial]: 5, // Trial Active
  [OfferIntents.CancelTrialHold]: 6, // Trial Hold
  [OfferIntents.ReturnOrder]: 7, // Return One-Time Order
  [OfferIntents.ReturnSubscription]: 8, // Return Subscription Order
  [OfferIntents.ReturnTrial]: 9, // Return Trial Order
  [OfferIntents.Resolve]: 10,
  [OfferIntents.ResolveSubscription]: 11,
};

export enum RetentionSettingSection {
  CustomerStageSetting = 1,
  RetentionControl = 2,
  HandoffRule = 3,
  SurveySetting = 4,
}

export const RetentionSettingSectionLabels: Record<RetentionSettingSection, string> = {
  [RetentionSettingSection.CustomerStageSetting]: 'Customer Stage Settings',
  [RetentionSettingSection.RetentionControl]: 'Retention Controls',
  [RetentionSettingSection.HandoffRule]: 'Handoff Rules',
  [RetentionSettingSection.SurveySetting]: 'Survey Settings',
};
